export default __webpack_public_path__ + "static/media/one.d317b00c.jpg";